import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';
import { NewOrderType } from 'types/order';

export type GQLGetOrder = {
  getOrder: NewOrderType;
};

export const getOrder = async (id: string) => {
  const query = gql`
    query GetOrder($id: ID!) {
      getOrder(_id: $id) {
        _id
        status
        order_id
        tokens {
          party_id
          email
          kind
          message
          token
          url
        }
        parties {
          _id
          name
          associations {
            parent
            linked_as
            party_id
            party_kind
            party_name
          }
          kinds
          member_of {
            _id
            kind
            name
          }
          emails {
            _id
            address
            kind
          }
        }
      }
    }
  `;

  const response = await graphQLClient().request<GQLGetOrder>(query, {
    id,
  });

  return response;
};
